// extracted by mini-css-extract-plugin
export default {"logoContainer":"AppSide__logoContainer___AmjUN","collapsed":"AppSide__collapsed___MvXMM","side":"AppSide__side___DPgjU","navigationWrapper":"AppSide__navigationWrapper___XMh18"};